<template>
  <div>
    <div class="container">
      <div class="headerWrap">
        <router-link to="/SystemConfig" class="systemTitle pointer" tag="span">< 返回上一页</router-link>
        <div class="breadcrumb">
          <span class="currPage">配置历史查询</span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>评估体系</el-breadcrumb-item>
            <el-breadcrumb-item>体系配置</el-breadcrumb-item>
            <el-breadcrumb-item>配置历史查询</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div style="padding: 20px 20px 0 20px;background-color: white" class="tableWrap">
        <el-form ref="form">
          <el-form-item label="年份">
            <el-date-picker
                v-model="year"
                align="left"
                type="year"
                placeholder="请选择年份...">
            </el-date-picker>
          </el-form-item>
          <div class="slide-btns clearfix">
            <el-form-item>
              <el-button class="search-btn" @click="submitForm()">筛选</el-button>
            </el-form-item>
          </div>
        </el-form>

        <el-table size="small" border style="width: 100%" :data="tableData">
          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="startTime" align="center" :formatter="formatTime"></el-table-column>
          <el-table-column label="操作用户" prop="updatorName" width="220" align="center">
          </el-table-column>
          <el-table-column label="操作" width="400" align="center">
            <template slot-scope="scope">
              <router-link :to="{ path:  '/LookHistoryTwo',  query: { sTime: scope.row.startTime }}" tag="div"
                           class="pointer mingxi">查看配置明细
              </router-link>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize"
                       :total="total"
                       layout="sizes,total,prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: '',
    data() {
      return {
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        total: null,
        year: new Date()
      }
    },
    mounted() {
      this.submitForm()
    },
    methods: {
      getData(refresh) {
        let year = this.year ? new Date(this.year).getFullYear() : null
        if (refresh) this.pageNo = 1;
        this.$http({
          method: "get",
          url: '/rest/ScoreSystemSettings/searchHistory',
          params: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            year: year
          }
        }).then(res => {
          this.tableData = res.data
        })
        this.$http({
          method: "get",
          url: '/rest/ScoreSystemSettings/countSearchHistory',
          params: {
            year: year
          }
        }).then(res => {
          this.total = res.data
        })
      },
      handleSizeChange(value) {
        this.pageSize = value
        this.getData(false)
      },
      handleCurrentChange(value) {
        this.pageNo = value
        this.getData(false)
      },
      formatTime(row, column, cellValue) {
        return moment(cellValue).format('YYYY-MM-DD')
      },
      submitForm() {
        this.getData(true)
      }
    },
  }
</script>

<style scoped>
  .mingxi {
    color: #81ba83;
    cursor: pointer;
  }

  .is-in-pagination input {
    width: 30px;
  }

  .headerWrap {
    position: absolute;
    top: -30px;
    z-index: 9999;
    background-color: #f4f4f4;
  }

  .systemTitle {
    background-color: #8299dc;
    color: white;
    padding: 5px 10px;
    border-radius: 20px;
    position: fixed;
    top: 70px;
    left: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/LookHistory.vue